import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'yearRange' })
export class YearRangePipe implements PipeTransform {
  transform(value: any[]): string {
    if (!Array.isArray(value)) {
      return '';
    }

    const startYear = value[0].split('-')[0];
    const endYear = value[1] ? value[1].split('-')[0] : 'Current';
    return `${startYear} - ${endYear}`;
  }
}
